import {
  ACCESS_TOKEN_KEY,
  ASSUMED_USER_COOKIE,
  LAT_LNG_COOKIE_NAME,
  LOCALE_COOKIE_NAME,
} from '@/constants/common'

import { getClientName } from '../external'
import { getCookieValue } from '../helper'

interface CreateCartParams {
  vendor?: string
  product_details: any
  is_login_request: boolean
  cart_id: string
  cart_type?: string
  campaign_id?: string
}

const createCart = async (params: CreateCartParams) => {
  const token = getCookieValue(ACCESS_TOKEN_KEY)

  const headers: Record<string, string> = {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  }
  const latLong = getCookieValue(LAT_LNG_COOKIE_NAME)
  const assumedUser = getCookieValue(ASSUMED_USER_COOKIE)
  const clientName = getClientName()
  const locale = getCookieValue(LOCALE_COOKIE_NAME) || 'hi'

  if (latLong) {
    headers['X-LATLONG'] = latLong
  }
  if (clientName) {
    headers['X-CLIENT-NAME'] = clientName
  }
  if (assumedUser) {
    headers['ASSUMED-USER'] = assumedUser
  }
  if (locale) {
    headers['X-LANGUAGE'] = locale
  }

  const response = await fetch(
    `${process.env.NEXT_PUBLIC_API_BASE_URL}/hyperlocal/v1/create-cart`,
    {
      method: 'POST',
      headers,
      body: JSON.stringify(params),
      keepalive: true, // ensures request is sent even if page unloads
    },
  )

  const data = await response.json()

  if (!response.ok) {
    throw data
  }

  return data as { cart_id: string }
}

export default createCart
